<template>
  <div>
    <b-sidebar
      id="sidebar-menu"
      v-model="$store.state.slidebarCustom"
      backdrop
      shadow
      backdrop-variant="dark"
      aria-labelledby="sidebar-menu-title"
      @hidden="hide()"
      no-header
    >
      <template>
        <div>
          <div
            class="p-3 menu-header border-bottom d-flex justify-content-between align-items-center"
          >
            <label
              class="m-0 header-text"
              :style="`color: ${$store.state.colorPrimary}`"
              ><strong>เมนู</strong></label
            >
            <label
              class="m-0 pointer"
              @click="$store.commit('toggleSidebarCustom')"
              ><b-icon icon="x-circle-fill"></b-icon
            ></label>
          </div>
          <div
            class="menu-item"
            v-for="(menu, index) in menuOption"
            :key="index"
            @click="gotoPath(menu)"
            :style="
              $store.state.slidebarCurrent == menu.id
                ? `color: ${$store.state.colorPrimary}; border-left: 4px solid ${$store.state.colorSecondary}; font-weight: bold;`
                : ``
            "
          >
            <label>{{ menu.name }}</label>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="menu-item border-top" @click="handleLogout">
          <label>ออกจากระบบ</label>
        </div>
      </template>
    </b-sidebar>
    <b-modal
      ref="logOutModal"
      id="logOutModal"
      centered
      hide-header
      hide-footer
    >
      <div class="modal-header">
        <h4>ออกจากระบบ</h4>
        <button
          type="button"
          aria-label="Close"
          class="close"
          @click="$bvModal.hide('logOutModal')"
        >
          ×
        </button>
      </div>
      <div class="text-center px-md-5 py-4">
        <p class="text-text font-weight-bold">
          คุณแน่ใจหรือไม่ว่าคุณต้องการออกจากระบบ?
        </p>
      </div>
      <div class="form-inline justify-content-center mt-2">
        <b-button
          class="mr-2 btn-modal"
          variant="secondary"
          @click="$bvModal.hide('logOutModal')"
          >ไม่</b-button
        >
        <b-button
          class="ml-2 btn-modal-submit text-white"
          :style="$store.state.backgroundSecondary"
          @click="logout"
          >ใช่</b-button
        >
      </div>
    </b-modal>

    <b-modal
      ref="alertModal"
      id="alertModal"
      hide-header
      hide-footer
      centered
      size="sm"
      no-close-on-backdrop
    >
      <div class="text-center">
        <img
          src="@/assets/images/icons/loading.svg"
          alt="loading"
          class="mb-3 img"
        />
        <p class="text-text font-weight-bold">กรุณารอสักครู่...</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "SlidebarCustom",
  components: {},
  data() {
    return {
      showSlide: false,
      menuCurrent: 0,
      menuOption: [
        {
          id: 1,
          path: "/home",
          name: "หน้าแรก",
        },
        {
          id: 2,
          path: "/report",
          name: "ประวัติการสั่งซื้อ",
        },
        {
          id: 3,
          path: "/point",
          name: "ประวัติคะแนนสะสม",
        },
        {
          id: 4,
          path: "/customer",
          name: "ลูกค้า",
        },
      ],
    };
  },
  methods: {
    async show() {
      this.showSlide = true;
    },
    hide() {
      this.showSlide = false;
    },
    gotoPath(menu) {
      this.$store.dispatch("setSlideBarCurrent", menu.id);
      this.$router.push(menu.path);
    },
    handleLogout() {
      this.$refs.logOutModal.show();
    },
    logout() {
      this.$refs.logOutModal.hide();
      this.$refs.alertModal.show();
      var timestamp = new Date().getTime();
      this.$cookies.set("crm-timestamp", timestamp);
      this.$cookies.remove("tnl-username");
      this.$cookies.remove("back_office_admin_token");
      this.$cookies.remove("username");
      this.$cookies.remove("branch_id");
      this.$cookies.remove("plant_id");
      this.$cookies.remove("user_guid");
      this.$cookies.remove("booth");
      this.$cookies.remove("spa");

      window.location.href = "/";
    },
  },
};
</script>

<style scoped>
.menu-header {
  height: 10%;
}
.menu-item {
  display: flex;
  align-items: center;
  font-size: 2vh;
  padding: 16px;
  border-bottom: 1px solid #f1f1f1;
  cursor: pointer;
}
</style>
